import { BUNDLED_EXPERIENCES_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { BundledExperienceRowView } from './types';

export function buildBundledExperienceQueueItem(row: BundledExperienceRowView): ApprovalQueueItem {
  return {
    categoryId: BUNDLED_EXPERIENCES_CATEGORY.id,
    categoryLabel: BUNDLED_EXPERIENCES_CATEGORY.label,
    description: `${row.bundledExperience} needs bundled-experience review.`,
    details: [
      { label: 'Linked deal options', value: row.linkedDealOptions.join(', ') || 'N/A' },
      { label: 'Validity from', value: row.bookBy || 'N/A' },
      { label: 'Validity to', value: row.travelTo || 'N/A' },
      { label: 'Currency', value: row.currency || 'N/A' },
      { label: 'Children age', value: row.childAge || 'N/A' },
    ],
    id: row.id,
    title: row.bundledExperience,
  };
}

export function getBundledExperienceSearchText(row: BundledExperienceRowView) {
  return [row.bundledExperience, row.linkedDealOptions.join(' '), row.currency, row.childAge, row.statusLabel]
    .filter(Boolean)
    .join(' ');
}
